import { Software } from '@dh/types';

/**
 * Filters software with temporary IDs (newly added, not yet created in backend)
 */
export const filterNewSoftware = (software: Software[]): Software[] =>
    software.filter((sw) => sw.documentId.startsWith('temp-'));

/**
 * Filters software with real IDs (already exists in backend)
 */
export const filterExistingSoftware = (software: Software[]): Software[] =>
    software.filter((sw) => !sw.documentId.startsWith('temp-'));

/**
 * Finds software that was deleted (exists in original but not in current)
 */
export const findDeletedSoftware = (original: Software[], current: Software[]): Software[] =>
    original.filter(
        (originalSw) => !current.find((currentSw) => currentSw.documentId === originalSw.documentId)
    );

/**
 * Checks if software properties have changed
 */
export const hasSoftwareChanged = (original: Software, current: Software): boolean =>
    original.name !== current.name ||
    original.description !== current.description ||
    original.repository_link !== current.repository_link;
